import React from 'react';

import { useGraphQLMutation } from '@betterment/graphql';
import { Box, Button, Dialog, H1, ListRow, Text } from '@betterment/samba-react';
import { useNotifications } from '@betterment/shared-components';

import { SetDefaultModalProps } from './data';
import { UpdateFirmDefaultBillingPlanDocument } from './graphql/mutation.updateFirmDefaultBillingPlan.generated';

import { UpdateDefaultBillingPlanMutationInput } from '../../../graphql/schema';

const SetDefaultModal: React.FC<SetDefaultModalProps> = ({ isOpen, closeHandler, billingPlan, defaultBillingPlan }) => {
  const [submitFirmDefaultBillingPlan, { loading }] = useGraphQLMutation(UpdateFirmDefaultBillingPlanDocument);
  const { showNotification } = useNotifications();

  const submit = async () => {
    const payload: UpdateDefaultBillingPlanMutationInput = {
      billingPlanId: billingPlan.id,
    };

    try {
      await submitFirmDefaultBillingPlan({ variables: { input: payload } });
    } catch {
      return;
    }
    showNotification({ type: 'success', message: `${billingPlan.name} is now the default.` });
    closeHandler();
  };

  return (
    <Dialog open={isOpen} onOpenChange={closeHandler}>
      <Dialog.Content
        size="large"
        css={{
          p: 'space.400',
        }}
      >
        <Dialog.Title asChild={true}>
          <H1 variant="title400" css={{ marginBottom: 'space.200' }}>
            Change default plan?
          </H1>
        </Dialog.Title>
        <Dialog.Description asChild={true}>
          <Box>
            <ListRow>
              <ListRow.LeadingContent>
                <Text color="text.weak">Current Default:</Text>
              </ListRow.LeadingContent>
              <ListRow.TrailingContent>
                <Text css={{ paddingLeft: 'space.200' }}>{defaultBillingPlan?.name}</Text>
              </ListRow.TrailingContent>
            </ListRow>

            <ListRow>
              <ListRow.LeadingContent>
                <Text color="text.weak">New Default:</Text>
              </ListRow.LeadingContent>
              <ListRow.TrailingContent>
                <Text css={{ paddingLeft: 'space.200' }}>{billingPlan.name}</Text>
              </ListRow.TrailingContent>
            </ListRow>

            <Box css={{ mt: 'space.200' }}>
              <Text variant="text100">
                All new clients onboarded after this point will automatically use the new default billing plan. However,
                existing clients' plans will not be altered unless changed manually.
              </Text>
            </Box>
            <Box css={{ display: 'flex', gap: 'space.200', marginTop: 'space.400' }}>
              <Button variant="solidPrimary" onClick={() => void submit()} loading={loading}>
                Continue
              </Button>
              <Button variant="solidSecondary" onClick={() => closeHandler()}>
                Close
              </Button>
            </Box>
          </Box>
        </Dialog.Description>
      </Dialog.Content>
    </Dialog>
  );
};

export default SetDefaultModal;
